import { Form, useFormikContext } from 'formik';
import React from 'react';

import { EntityDetailsFields } from 'common/components/entity-details';
import { useStore } from 'core/store';
import { ErrorAlert } from '../quote-errors';
import { HintFlagItem } from '../hint-flag-item';
import { offerDetailsCodes } from '../quote-forms/quote-forms.constants';

const OfferDetails = () => {
  const {
    quote: { getAlerts }
  } = useStore();

  const { values, errors } = useFormikContext();

  const alerts = getAlerts(offerDetailsCodes, values.policyType);
  const anyAlerts = getAlerts().length > 0;
  const hasEntityErrors = errors?.entity;

  return (
    <Form>
      {!hasEntityErrors && !anyAlerts && <HintFlagItem message="Select the main applicant's entity type" />}
      {alerts.length > 0 && <ErrorAlert alerts={alerts} id="error-alert-offer-details" />}
      <EntityDetailsFields title="Offer Details" />
    </Form>
  );
};

export default OfferDetails;
